/**
 * Central client configuration — single source of truth (Stuttgart only).
 */
export const CONFIG = {
  region: {
    name: 'Stuttgart',
    center: { lat: 48.6900, lon: 9.2219 },
    initialAltitude: 220000, // meters — hoch genug, dass der 80-km-Radius komplett sichtbar ist
    // Nur Zentraleuropa laden/anzeigen: außerhalb dieser Box lädt Cesium keine
    // Basiskarten-Kacheln (spart MapTiler-Kontingent) und die Kamera wird
    // sanft zurückgehalten. Großzügig für Orientierung rund um Stuttgart.
    bounds: { west: 2.0, south: 43.0, east: 24.0, north: 56.0 }
  },
  airport: {
    code: 'STR',
    icao: 'EDDS', // für den Abgleich mit der Routen-Datenbank (adsb.lol)
    name: 'Stuttgart Airport (STR)',
    lat: 48.6900,
    lon: 9.2219
  },
  data: {
    pollIntervalMs: 5000,
    radiusKm: 80,
    historyMinutes: 30, // speist Trails UND die Zeitleiste (Rückspulen)
    staleAfterMs: 30000,
    // Server-seitiger 30-min-Logger (optional, siehe server/README.md).
    // Nicht deployed? Kein Problem — die App startet dann ohne Vorgeschichte.
    historyUrl: '/history'
  },
  viz: {
    altitudeExaggerationFlat: 1.5,
    altitudeExaggerationTerrain: 1.0,
    trailMinutes: 10 // sichtbare Trail-Länge (History selbst hält 30 min vor)
  },
  offline: {
    // Offline-Karten-Abdeckung: Radius (km) pro Zoom-Level.
    // Grob = ganze Region, fein = nur Stuttgart-Zentrum (hält den Download klein).
    zoomRadii: {
      6: 100, 7: 100, 8: 100, 9: 100, 10: 100, 11: 100,
      12: 60, 13: 30, 14: 15
    },
    autoPrefetchDays: 7 // automatisch höchstens einmal pro Woche aktualisieren
  }
};
